import { render, staticRenderFns } from "./addMerchant.vue?vue&type=template&id=e115b9c0&scoped=true"
import script from "./addMerchant.vue?vue&type=script&lang=js"
export * from "./addMerchant.vue?vue&type=script&lang=js"
import style0 from "./addMerchant.vue?vue&type=style&index=0&id=e115b9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e115b9c0",
  null
  
)

export default component.exports